var map = {
	"./af": 66807,
	"./af.d": 51602,
	"./af.d.ts": 51602,
	"./af.js": 66807,
	"./ak": 62164,
	"./ak.d": 70017,
	"./ak.d.ts": 70017,
	"./ak.js": 62164,
	"./am": 39954,
	"./am.d": 45843,
	"./am.d.ts": 45843,
	"./am.js": 39954,
	"./an": 40863,
	"./an.d": 42746,
	"./an.d.ts": 42746,
	"./an.js": 40863,
	"./ar": 13347,
	"./ar.d": 72462,
	"./ar.d.ts": 72462,
	"./ar.js": 13347,
	"./ars": 23366,
	"./ars.d": 4457,
	"./ars.d.ts": 4457,
	"./ars.js": 23366,
	"./as": 15356,
	"./as.d": 52201,
	"./as.d.ts": 52201,
	"./as.js": 15356,
	"./asa": 94885,
	"./asa.d": 4354,
	"./asa.d.ts": 4354,
	"./asa.js": 94885,
	"./ast": 80458,
	"./ast.d": 37785,
	"./ast.d.ts": 37785,
	"./ast.js": 80458,
	"./az": 30475,
	"./az.d": 87542,
	"./az.d.ts": 87542,
	"./az.js": 30475,
	"./bal": 82681,
	"./bal.d": 52922,
	"./bal.d.ts": 52922,
	"./bal.js": 82681,
	"./be": 28525,
	"./be.d": 93808,
	"./be.d.ts": 93808,
	"./be.js": 28525,
	"./bem": 51782,
	"./bem.d": 20089,
	"./bem.d.ts": 20089,
	"./bem.js": 51782,
	"./bez": 33943,
	"./bez.d": 8072,
	"./bez.d.ts": 8072,
	"./bez.js": 33943,
	"./bg": 19563,
	"./bg.d": 61098,
	"./bg.d.ts": 61098,
	"./bg.js": 19563,
	"./bho": 91037,
	"./bho.d": 8706,
	"./bho.d.ts": 8706,
	"./bho.js": 91037,
	"./bm": 17285,
	"./bm.d": 69768,
	"./bm.d.ts": 69768,
	"./bm.js": 17285,
	"./bn": 87548,
	"./bn.d": 44333,
	"./bn.d.ts": 44333,
	"./bn.js": 87548,
	"./bo": 85539,
	"./bo.d": 20738,
	"./bo.d.ts": 20738,
	"./bo.js": 85539,
	"./br": 1736,
	"./br.d": 35073,
	"./br.d.ts": 35073,
	"./br.js": 1736,
	"./brx": 44882,
	"./brx.d": 47517,
	"./brx.d.ts": 47517,
	"./brx.js": 44882,
	"./bs": 93823,
	"./bs.d": 81126,
	"./bs.d.ts": 81126,
	"./bs.js": 93823,
	"./ca": 48488,
	"./ca.d": 737,
	"./ca.d.ts": 737,
	"./ca.js": 48488,
	"./ce": 16340,
	"./ce.d": 86533,
	"./ce.d.ts": 86533,
	"./ce.js": 16340,
	"./ceb": 78052,
	"./ceb.d": 83503,
	"./ceb.d.ts": 83503,
	"./ceb.js": 78052,
	"./cgg": 65769,
	"./cgg.d": 45190,
	"./cgg.d.ts": 45190,
	"./cgg.js": 65769,
	"./chr": 48753,
	"./chr.d": 92606,
	"./chr.d.ts": 92606,
	"./chr.js": 48753,
	"./ckb": 63418,
	"./ckb.d": 69505,
	"./ckb.d.ts": 69505,
	"./ckb.js": 63418,
	"./cs": 6530,
	"./cs.d": 77311,
	"./cs.d.ts": 77311,
	"./cs.js": 6530,
	"./cy": 98768,
	"./cy.d": 66793,
	"./cy.d.ts": 66793,
	"./cy.js": 98768,
	"./da": 31051,
	"./da.d": 35262,
	"./da.d.ts": 35262,
	"./da.js": 31051,
	"./de": 61807,
	"./de.d": 11570,
	"./de.d.ts": 11570,
	"./de.js": 61807,
	"./doi": 76206,
	"./doi.d": 20333,
	"./doi.d.ts": 20333,
	"./doi.js": 76206,
	"./dsb": 45023,
	"./dsb.d": 19500,
	"./dsb.d.ts": 19500,
	"./dsb.js": 45023,
	"./dv": 56882,
	"./dv.d": 70459,
	"./dv.d.ts": 70459,
	"./dv.js": 56882,
	"./dz": 8342,
	"./dz.d": 52031,
	"./dz.d.ts": 52031,
	"./dz.js": 8342,
	"./ee": 66470,
	"./ee.d": 56463,
	"./ee.d.ts": 56463,
	"./ee.js": 66470,
	"./el": 79629,
	"./el.d": 87876,
	"./el.d.ts": 87876,
	"./el.js": 79629,
	"./en": 20139,
	"./en.d": 55006,
	"./en.d.ts": 55006,
	"./en.js": 20139,
	"./eo": 55044,
	"./eo.d": 22233,
	"./eo.d.ts": 22233,
	"./eo.js": 55044,
	"./es": 72640,
	"./es.d": 85013,
	"./es.d.ts": 85013,
	"./es.js": 72640,
	"./et": 32021,
	"./et.d": 50396,
	"./et.d.ts": 50396,
	"./et.js": 32021,
	"./eu": 3830,
	"./eu.d": 29247,
	"./eu.d.ts": 29247,
	"./eu.js": 3830,
	"./fa": 62421,
	"./fa.d": 15352,
	"./fa.d.ts": 15352,
	"./fa.js": 62421,
	"./ff": 19392,
	"./ff.d": 70233,
	"./ff.d.ts": 70233,
	"./ff.js": 19392,
	"./fi": 2589,
	"./fi.d": 3712,
	"./fi.d.ts": 3712,
	"./fi.js": 2589,
	"./fil": 76725,
	"./fil.d": 85646,
	"./fil.d.ts": 85646,
	"./fil.js": 76725,
	"./fo": 17855,
	"./fo.d": 40934,
	"./fo.d.ts": 40934,
	"./fo.js": 17855,
	"./fr": 34876,
	"./fr.d": 18381,
	"./fr.d.ts": 18381,
	"./fr.js": 34876,
	"./fur": 93555,
	"./fur.d": 34524,
	"./fur.d.ts": 34524,
	"./fur.js": 93555,
	"./fy": 10029,
	"./fy.d": 58352,
	"./fy.d.ts": 58352,
	"./fy.js": 10029,
	"./ga": 97788,
	"./ga.d": 61581,
	"./ga.d.ts": 61581,
	"./ga.js": 97788,
	"./gd": 28935,
	"./gd.d": 24238,
	"./gd.d.ts": 24238,
	"./gd.js": 28935,
	"./gl": 50607,
	"./gl.d": 61014,
	"./gl.d.ts": 61014,
	"./gl.js": 50607,
	"./gsw": 15169,
	"./gsw.d": 18814,
	"./gsw.d.ts": 18814,
	"./gsw.js": 15169,
	"./gu": 91584,
	"./gu.d": 33721,
	"./gu.d.ts": 33721,
	"./gu.js": 91584,
	"./guw": 59099,
	"./guw.d": 65652,
	"./guw.d.ts": 65652,
	"./guw.js": 59099,
	"./gv": 25881,
	"./gv.d": 8132,
	"./gv.d.ts": 8132,
	"./gv.js": 25881,
	"./ha": 53695,
	"./ha.d": 69914,
	"./ha.d.ts": 69914,
	"./ha.js": 53695,
	"./haw": 24774,
	"./haw.d": 32505,
	"./haw.d.ts": 32505,
	"./haw.js": 24774,
	"./he": 74523,
	"./he.d": 8678,
	"./he.d.ts": 8678,
	"./he.js": 74523,
	"./hi": 79639,
	"./hi.d": 93906,
	"./hi.d.ts": 93906,
	"./hi.js": 79639,
	"./hnj": 11942,
	"./hnj.d": 39897,
	"./hnj.d.ts": 39897,
	"./hnj.js": 11942,
	"./hr": 83522,
	"./hr.d": 46147,
	"./hr.d.ts": 46147,
	"./hr.js": 83522,
	"./hsb": 14107,
	"./hsb.d": 86592,
	"./hsb.d.ts": 86592,
	"./hsb.js": 14107,
	"./hu": 43307,
	"./hu.d": 78262,
	"./hu.d.ts": 78262,
	"./hu.js": 43307,
	"./hy": 75687,
	"./hy.d": 48290,
	"./hy.d.ts": 48290,
	"./hy.js": 75687,
	"./ia": 31182,
	"./ia.d": 30815,
	"./ia.d.ts": 30815,
	"./ia.js": 31182,
	"./id": 56849,
	"./id.d": 92688,
	"./id.d.ts": 92688,
	"./id.js": 56849,
	"./ig": 504,
	"./ig.d": 72181,
	"./ig.d.ts": 72181,
	"./ig.js": 504,
	"./ii": 28198,
	"./ii.d": 16279,
	"./ii.d.ts": 16279,
	"./ii.js": 28198,
	"./io": 81200,
	"./io.d": 52717,
	"./io.d.ts": 52717,
	"./io.js": 81200,
	"./is": 98772,
	"./is.d": 66241,
	"./is.d.ts": 66241,
	"./is.js": 98772,
	"./it": 83841,
	"./it.d": 38048,
	"./it.d.ts": 38048,
	"./it.js": 83841,
	"./iu": 99858,
	"./iu.d": 42067,
	"./iu.d.ts": 42067,
	"./iu.js": 99858,
	"./ja": 23529,
	"./ja.d": 3732,
	"./ja.d.ts": 3732,
	"./ja.js": 23529,
	"./jbo": 7539,
	"./jbo.d": 63324,
	"./jbo.d.ts": 63324,
	"./jbo.js": 7539,
	"./jgo": 67890,
	"./jgo.d": 37017,
	"./jgo.d.ts": 37017,
	"./jgo.js": 67890,
	"./jmc": 92088,
	"./jmc.d": 75891,
	"./jmc.d.ts": 75891,
	"./jmc.js": 92088,
	"./jv": 2316,
	"./jv.d": 7901,
	"./jv.d.ts": 7901,
	"./jv.js": 2316,
	"./jw": 10419,
	"./jw.d": 34322,
	"./jw.d.ts": 34322,
	"./jw.js": 10419,
	"./ka": 38912,
	"./ka.d": 49785,
	"./ka.d.ts": 49785,
	"./ka.js": 38912,
	"./kab": 86808,
	"./kab.d": 64779,
	"./kab.d.ts": 64779,
	"./kab.js": 86808,
	"./kaj": 44720,
	"./kaj.d": 60659,
	"./kaj.d.ts": 60659,
	"./kaj.js": 44720,
	"./kcg": 5445,
	"./kcg.d": 39194,
	"./kcg.d.ts": 39194,
	"./kcg.js": 5445,
	"./kde": 69360,
	"./kde.d": 26463,
	"./kde.d.ts": 26463,
	"./kde.js": 69360,
	"./kea": 50293,
	"./kea.d": 58638,
	"./kea.d.ts": 58638,
	"./kea.js": 50293,
	"./kk": 69714,
	"./kk.d": 84015,
	"./kk.d.ts": 84015,
	"./kk.js": 69714,
	"./kkj": 50602,
	"./kkj.d": 83745,
	"./kkj.d.ts": 83745,
	"./kkj.js": 50602,
	"./kl": 25627,
	"./kl.d": 64954,
	"./kl.d.ts": 64954,
	"./kl.js": 25627,
	"./km": 52276,
	"./km.d": 46661,
	"./km.d.ts": 46661,
	"./km.js": 52276,
	"./kn": 90045,
	"./kn.d": 78432,
	"./kn.d.ts": 78432,
	"./kn.js": 90045,
	"./ko": 40478,
	"./ko.d": 24979,
	"./ko.d.ts": 24979,
	"./ko.js": 40478,
	"./ks": 23066,
	"./ks.d": 42263,
	"./ks.d.ts": 42263,
	"./ks.js": 23066,
	"./ksb": 46602,
	"./ksb.d": 18737,
	"./ksb.d.ts": 18737,
	"./ksb.js": 46602,
	"./ksh": 79656,
	"./ksh.d": 53303,
	"./ksh.d.ts": 53303,
	"./ksh.js": 79656,
	"./ku": 21820,
	"./ku.d": 69805,
	"./ku.d.ts": 69805,
	"./ku.js": 21820,
	"./kw": 55526,
	"./kw.d": 17915,
	"./kw.d.ts": 17915,
	"./kw.js": 55526,
	"./ky": 27832,
	"./ky.d": 7697,
	"./ky.d.ts": 7697,
	"./ky.js": 27832,
	"./lag": 30282,
	"./lag.d": 91157,
	"./lag.d.ts": 91157,
	"./lag.js": 30282,
	"./lb": 79302,
	"./lb.d": 48255,
	"./lb.d.ts": 48255,
	"./lb.js": 79302,
	"./lg": 7785,
	"./lg.d": 58544,
	"./lg.d.ts": 58544,
	"./lg.js": 7785,
	"./lij": 87205,
	"./lij.d": 56902,
	"./lij.d.ts": 56902,
	"./lij.js": 87205,
	"./lkt": 83453,
	"./lkt.d": 88266,
	"./lkt.d.ts": 88266,
	"./lkt.js": 83453,
	"./ln": 47010,
	"./ln.d": 66683,
	"./ln.d.ts": 66683,
	"./ln.js": 47010,
	"./lo": 14897,
	"./lo.d": 48904,
	"./lo.d.ts": 48904,
	"./lo.js": 14897,
	"./lt": 85472,
	"./lt.d": 19781,
	"./lt.d.ts": 19781,
	"./lt.js": 85472,
	"./lv": 32618,
	"./lv.d": 55347,
	"./lv.d.ts": 55347,
	"./lv.js": 32618,
	"./mas": 8497,
	"./mas.d": 69266,
	"./mas.d.ts": 69266,
	"./mas.js": 8497,
	"./mg": 3572,
	"./mg.d": 61273,
	"./mg.d.ts": 61273,
	"./mg.js": 3572,
	"./mgo": 98855,
	"./mgo.d": 90764,
	"./mgo.d.ts": 90764,
	"./mgo.js": 98855,
	"./mk": 32224,
	"./mk.d": 85445,
	"./mk.d.ts": 85445,
	"./mk.js": 32224,
	"./ml": 75253,
	"./ml.d": 51884,
	"./ml.d.ts": 51884,
	"./ml.js": 75253,
	"./mn": 17235,
	"./mn.d": 45702,
	"./mn.d.ts": 45702,
	"./mn.js": 17235,
	"./mo": 16972,
	"./mo.d": 99649,
	"./mo.d.ts": 99649,
	"./mo.js": 16972,
	"./mr": 16367,
	"./mr.d": 27842,
	"./mr.d.ts": 27842,
	"./mr.js": 16367,
	"./ms": 82008,
	"./ms.d": 89133,
	"./ms.d.ts": 89133,
	"./ms.js": 82008,
	"./mt": 22861,
	"./mt.d": 83092,
	"./mt.d.ts": 83092,
	"./mt.js": 22861,
	"./my": 25658,
	"./my.d": 48995,
	"./my.d.ts": 48995,
	"./my.js": 25658,
	"./nah": 84841,
	"./nah.d": 86226,
	"./nah.d.ts": 86226,
	"./nah.js": 84841,
	"./naq": 28018,
	"./naq.d": 6965,
	"./naq.d.ts": 6965,
	"./naq.js": 28018,
	"./nb": 3716,
	"./nb.d": 34069,
	"./nb.d.ts": 34069,
	"./nb.js": 3716,
	"./nd": 65954,
	"./nd.d": 92703,
	"./nd.d.ts": 92703,
	"./nd.js": 65954,
	"./ne": 33841,
	"./ne.d": 94620,
	"./ne.d.ts": 94620,
	"./ne.js": 33841,
	"./nl": 14746,
	"./nl.d": 78167,
	"./nl.d.ts": 78167,
	"./nl.js": 14746,
	"./nn": 34896,
	"./nn.d": 10313,
	"./nn.d.ts": 10313,
	"./nn.js": 34896,
	"./nnh": 86378,
	"./nnh.d": 17525,
	"./nnh.d.ts": 17525,
	"./nnh.js": 86378,
	"./no": 41767,
	"./no.d": 30574,
	"./no.d.ts": 30574,
	"./no.js": 41767,
	"./nqo": 86540,
	"./nqo.d": 98423,
	"./nqo.d.ts": 98423,
	"./nqo.js": 86540,
	"./nr": 41076,
	"./nr.d": 5861,
	"./nr.d.ts": 5861,
	"./nr.js": 41076,
	"./nso": 16842,
	"./nso.d": 67825,
	"./nso.d.ts": 67825,
	"./nso.js": 16842,
	"./ny": 44565,
	"./ny.d": 11576,
	"./ny.d.ts": 11576,
	"./ny.js": 44565,
	"./nyn": 54475,
	"./nyn.d": 58316,
	"./nyn.d.ts": 58316,
	"./nyn.js": 54475,
	"./om": 51168,
	"./om.d": 32121,
	"./om.d.ts": 32121,
	"./om.js": 51168,
	"./or": 81997,
	"./or.d": 20240,
	"./or.d.ts": 20240,
	"./or.js": 81997,
	"./os": 32686,
	"./os.d": 50915,
	"./os.d.ts": 50915,
	"./os.js": 32686,
	"./osa": 44115,
	"./osa.d": 88624,
	"./osa.d.ts": 88624,
	"./osa.js": 44115,
	"./pa": 33111,
	"./pa.d": 60242,
	"./pa.d.ts": 60242,
	"./pa.js": 33111,
	"./pap": 10479,
	"./pap.d": 93792,
	"./pap.d.ts": 93792,
	"./pap.js": 10479,
	"./pcm": 35698,
	"./pcm.d": 40481,
	"./pcm.d.ts": 40481,
	"./pcm.js": 35698,
	"./pl": 47700,
	"./pl.d": 86433,
	"./pl.d.ts": 86433,
	"./pl.js": 47700,
	"./prg": 72597,
	"./prg.d": 14910,
	"./prg.d.ts": 14910,
	"./prg.js": 72597,
	"./ps": 49353,
	"./ps.d": 1352,
	"./ps.d.ts": 1352,
	"./ps.js": 49353,
	"./pt": 892,
	"./pt-PT": 66141,
	"./pt-PT.d": 6706,
	"./pt-PT.d.ts": 6706,
	"./pt-PT.js": 66141,
	"./pt.d": 55094,
	"./pt.d.ts": 55094,
	"./pt.js": 892,
	"./rm": 70677,
	"./rm.d": 80376,
	"./rm.d.ts": 80376,
	"./rm.js": 70677,
	"./ro": 12659,
	"./ro.d": 62162,
	"./ro.d.ts": 62162,
	"./ro.js": 12659,
	"./rof": 43273,
	"./rof.d": 10550,
	"./rof.d.ts": 10550,
	"./rof.js": 43273,
	"./ru": 18285,
	"./ru.d": 7024,
	"./ru.d.ts": 7024,
	"./ru.js": 18285,
	"./rwk": 35110,
	"./rwk.d": 63877,
	"./rwk.d.ts": 63877,
	"./rwk.js": 35110,
	"./sah": 69330,
	"./sah.d": 7933,
	"./sah.d.ts": 7933,
	"./sah.js": 69330,
	"./saq": 67273,
	"./saq.d": 20938,
	"./saq.d.ts": 20938,
	"./saq.js": 67273,
	"./sat": 38790,
	"./sat.d": 59345,
	"./sat.d.ts": 59345,
	"./sat.js": 38790,
	"./sc": 45026,
	"./sc.d": 35039,
	"./sc.d.ts": 35039,
	"./sc.js": 45026,
	"./scn": 84614,
	"./scn.d": 14773,
	"./scn.d.ts": 14773,
	"./scn.js": 84614,
	"./sd": 4811,
	"./sd.d": 27018,
	"./sd.d.ts": 27018,
	"./sd.js": 4811,
	"./sdh": 68675,
	"./sdh.d": 91488,
	"./sdh.d.ts": 91488,
	"./sdh.js": 68675,
	"./se": 82788,
	"./se.d": 15317,
	"./se.d.ts": 15317,
	"./se.js": 82788,
	"./seh": 30934,
	"./seh.d": 5609,
	"./seh.d.ts": 5609,
	"./seh.js": 30934,
	"./ses": 4715,
	"./ses.d": 91788,
	"./ses.d.ts": 91788,
	"./ses.js": 4715,
	"./sg": 97710,
	"./sg.d": 70115,
	"./sg.d.ts": 70115,
	"./sg.js": 97710,
	"./sh": 37191,
	"./sh.d": 72910,
	"./sh.d.ts": 72910,
	"./sh.js": 37191,
	"./shi": 21488,
	"./shi.d": 53519,
	"./shi.d.ts": 53519,
	"./shi.js": 21488,
	"./si": 30320,
	"./si.d": 67049,
	"./si.d.ts": 67049,
	"./si.js": 30320,
	"./sk": 10170,
	"./sk.d": 59415,
	"./sk.d.ts": 59415,
	"./sk.js": 10170,
	"./sl": 87683,
	"./sl.d": 48962,
	"./sl.d.ts": 48962,
	"./sl.js": 87683,
	"./sma": 75557,
	"./sma.d": 3134,
	"./sma.d.ts": 3134,
	"./sma.js": 75557,
	"./smi": 70445,
	"./smi.d": 89382,
	"./smi.d.ts": 89382,
	"./smi.js": 70445,
	"./smj": 45860,
	"./smj.d": 15215,
	"./smj.d.ts": 15215,
	"./smj.js": 45860,
	"./smn": 29592,
	"./smn.d": 7763,
	"./smn.d.ts": 7763,
	"./smn.js": 29592,
	"./sms": 64819,
	"./sms.d": 19828,
	"./sms.d.ts": 19828,
	"./sms.js": 64819,
	"./sn": 96645,
	"./sn.d": 35688,
	"./sn.d.ts": 35688,
	"./sn.js": 96645,
	"./so": 65926,
	"./so.d": 53467,
	"./so.d.ts": 53467,
	"./so.js": 65926,
	"./sq": 3880,
	"./sq.d": 20769,
	"./sq.d.ts": 20769,
	"./sq.js": 3880,
	"./sr": 34017,
	"./sr.d": 73004,
	"./sr.d.ts": 73004,
	"./sr.js": 34017,
	"./ss": 30642,
	"./ss.d": 92655,
	"./ss.d.ts": 92655,
	"./ss.js": 30642,
	"./ssy": 84135,
	"./ssy.d": 98044,
	"./ssy.d.ts": 98044,
	"./ssy.js": 84135,
	"./st": 36027,
	"./st.d": 82106,
	"./st.d.ts": 82106,
	"./st.js": 36027,
	"./su": 36500,
	"./su.d": 6565,
	"./su.d.ts": 6565,
	"./su.js": 36500,
	"./sv": 34621,
	"./sv.d": 7040,
	"./sv.d.ts": 7040,
	"./sv.js": 34621,
	"./sw": 24702,
	"./sw.d": 42131,
	"./sw.d.ts": 42131,
	"./sw.js": 24702,
	"./syr": 66728,
	"./syr.d": 17755,
	"./syr.d.ts": 17755,
	"./syr.js": 66728,
	"./ta": 82779,
	"./ta.d": 25742,
	"./ta.d.ts": 25742,
	"./ta.js": 82779,
	"./te": 61951,
	"./te.d": 96962,
	"./te.d.ts": 96962,
	"./te.js": 61951,
	"./teo": 20702,
	"./teo.d": 46073,
	"./teo.d.ts": 46073,
	"./teo.js": 20702,
	"./th": 66572,
	"./th.d": 41553,
	"./th.d.ts": 41553,
	"./th.js": 66572,
	"./ti": 71795,
	"./ti.d": 43286,
	"./ti.d.ts": 43286,
	"./ti.js": 71795,
	"./tig": 2426,
	"./tig.d": 96021,
	"./tig.d.ts": 96021,
	"./tig.js": 2426,
	"./tk": 70389,
	"./tk.d": 52604,
	"./tk.d.ts": 52604,
	"./tk.js": 70389,
	"./tl": 30240,
	"./tl.d": 66197,
	"./tl.d.ts": 66197,
	"./tl.js": 30240,
	"./tn": 94282,
	"./tn.d": 94819,
	"./tn.d.ts": 94819,
	"./tn.js": 94282,
	"./to": 64537,
	"./to.d": 70032,
	"./to.d.ts": 70032,
	"./to.js": 64537,
	"./tpi": 92309,
	"./tpi.d": 71610,
	"./tpi.d.ts": 71610,
	"./tpi.js": 92309,
	"./tr": 28110,
	"./tr.d": 61223,
	"./tr.d.ts": 61223,
	"./tr.js": 28110,
	"./ts": 77421,
	"./ts.d": 32932,
	"./ts.d.ts": 32932,
	"./ts.js": 77421,
	"./tzm": 37367,
	"./tzm.d": 32608,
	"./tzm.d.ts": 32608,
	"./tzm.js": 37367,
	"./ug": 77900,
	"./ug.d": 27505,
	"./ug.d.ts": 27505,
	"./ug.js": 77900,
	"./uk": 22824,
	"./uk.d": 1389,
	"./uk.d.ts": 1389,
	"./uk.js": 22824,
	"./und": 21535,
	"./und.d": 82200,
	"./und.d.ts": 82200,
	"./und.js": 21535,
	"./ur": 13607,
	"./ur.d": 87642,
	"./ur.d.ts": 87642,
	"./ur.js": 13607,
	"./uz": 43119,
	"./uz.d": 96498,
	"./uz.d.ts": 96498,
	"./uz.js": 43119,
	"./ve": 15433,
	"./ve.d": 52404,
	"./ve.d.ts": 52404,
	"./ve.js": 15433,
	"./vi": 81773,
	"./vi.d": 32432,
	"./vi.d.ts": 32432,
	"./vi.js": 81773,
	"./vo": 36143,
	"./vo.d": 66038,
	"./vo.d.ts": 66038,
	"./vo.js": 36143,
	"./vun": 99743,
	"./vun.d": 47368,
	"./vun.d.ts": 47368,
	"./vun.js": 99743,
	"./wa": 40972,
	"./wa.d": 22237,
	"./wa.d.ts": 22237,
	"./wa.js": 40972,
	"./wae": 67865,
	"./wae.d": 95522,
	"./wae.d.ts": 95522,
	"./wae.js": 67865,
	"./wo": 77970,
	"./wo.d": 32687,
	"./wo.d.ts": 32687,
	"./wo.js": 77970,
	"./xh": 66736,
	"./xh.d": 72141,
	"./xh.d.ts": 72141,
	"./xh.js": 66736,
	"./xog": 71820,
	"./xog.d": 6227,
	"./xog.d.ts": 6227,
	"./xog.js": 71820,
	"./yi": 55318,
	"./yi.d": 35943,
	"./yi.d.ts": 35943,
	"./yi.js": 55318,
	"./yo": 40480,
	"./yo.d": 41565,
	"./yo.d.ts": 41565,
	"./yo.js": 40480,
	"./yue": 36139,
	"./yue.d": 22236,
	"./yue.d.ts": 22236,
	"./yue.js": 36139,
	"./zh": 27122,
	"./zh.d": 10735,
	"./zh.d.ts": 10735,
	"./zh.js": 27122,
	"./zu": 31858,
	"./zu.d": 73544,
	"./zu.d.ts": 73544,
	"./zu.js": 31858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11973;